import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, File, Download } from 'lucide-react';
import styles from './FolderDetail.module.css';
import bgPattern from '../../../../Assets/BRANDING-BG.png';
import { Header } from '../header/Header';
import { DashboardSidebar } from '../DashboardSidebar/DashboardSidebar';

const CSAT_FILES = [
    {
        id: 1,
        name: 'Q4 2025 Customer Satisfaction Report.pdf',
        type: 'pdf',
        size: '2.4 MB',
        uploadedDate: 'Jan 10, 2026'
    },
    {
        id: 2,
        name: 'Q3 2025 QBR Presentation.pptx',
        type: 'pptx',
        size: '3.1 MB',
        uploadedDate: 'Oct 15, 2025'
    }
];

export const CSATFolder = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const navigate = useNavigate();

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.headerWrapper}>
                <Header onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
            </div>

            <div className={styles.mainWrapper}>
                <DashboardSidebar
                    isOpen={isSidebarOpen}
                    onClose={() => setIsSidebarOpen(false)}
                />

                <div className={styles.container} style={{ backgroundImage: `url(${bgPattern})` }}>
                    <div className={styles.pageHeader}>
                        <div className={styles.headerLeft}>
                            <button
                                className={styles.backButton}
                                onClick={() => navigate('/dashboard/qbr')}
                            >
                                <ArrowLeft size={20} />
                                Back to Shared Materials
                            </button>
                            <h1 className={styles.title}>CSAT</h1>
                            <p className={styles.subtitle}>
                                Customer satisfaction reports and survey results.
                            </p>
                        </div>
                        <div className={styles.headerRight}>
                            <span className={styles.fileCount}>{CSAT_FILES.length} files</span>
                        </div>
                    </div>

                    <div className={styles.filesGrid}>
                        {CSAT_FILES.map((file) => (
                            <div key={file.id} className={styles.fileCard}>
                                <div className={styles.fileIconContainer}>
                                    <File size={48} />
                                    <span className={styles.fileType}>{file.type}</span>
                                </div>
                                <div className={styles.fileInfo}>
                                    <h3 className={styles.fileName}>{file.name}</h3>
                                    <div className={styles.fileMeta}>
                                        <span className={styles.fileSize}>{file.size}</span>
                                        <span className={styles.separator}>•</span>
                                        <span className={styles.fileDate}>{file.uploadedDate}</span>
                                    </div>
                                </div>
                                <button className={styles.downloadButton}>
                                    <Download size={18} />
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CSATFolder;
